/* EELC header — mobile menu disclosure.
   Defined as a custom element so bindings survive section re-renders
   in the theme editor. */
class EelcHeaderNav extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.eelc-header__menu-btn');
    this.menu = this.querySelector('.eelc-header__mmenu');
    if (!this.button || !this.menu) return;

    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape' && this.isOpen()) {
        this.close();
        this.button.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (this.isOpen() && !this.contains(event.target)) this.close();
    });
  }

  isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    this.menu.classList.add('eelc-header__mmenu--open');
    this.button.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.menu.classList.remove('eelc-header__mmenu--open');
    this.button.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('eelc-header-nav')) {
  customElements.define('eelc-header-nav', EelcHeaderNav);
}
